<template>
    <div class="table-responsive">
        <table class="table table-hover no-overflow">
            <thead>
                <tr>
                    <th @click="$emit('sort', 'referenceNumber')">
                        Folio
                        <span v-if="contractStore.sortKey === 'referenceNumber'">
                            <i :class="contractStore.sortOrder === 1 ? 'fa fa-arrow-up' : 'fa fa-arrow-down'"></i>
                        </span>
                        <span v-else>
                            <i class="fas fa-sort"></i>
                        </span>
                    </th>
                    <th @click="$emit('sort', 'loanApplication.referenceNumber')">
                        Folio solicitud
                        <span v-if="contractStore.sortKey === 'loanApplication.referenceNumber'">
                            <i :class="contractStore.sortOrder === 1 ? 'fa fa-arrow-up' : 'fa fa-arrow-down'"></i>
                        </span>
                        <span v-else>
                            <i class="fas fa-sort"></i>
                        </span>
                    </th>
                    <th @click="$emit('sort', 'loanApplication.prospectus.referenceNumber')">
                        Folio prospecto
                        <span v-if="contractStore.sortKey === 'loanApplication.prospectus.referenceNumber'">
                            <i :class="contractStore.sortOrder === 1 ? 'fa fa-arrow-up' : 'fa fa-arrow-down'"></i>
                        </span>
                        <span v-else>
                            <i class="fas fa-sort"></i>
                        </span>
                    </th>
                    <th @click="$emit('sort', 'loanApplication.prospectus.quotations.referenceNumber')">
                        Folio cotización
                        <span v-if="contractStore.sortKey === 'loanApplication.prospectus.quotations.referenceNumber'">
                            <i :class="contractStore.sortOrder === 1 ? 'fa fa-arrow-up' : 'fa fa-arrow-down'"></i>
                        </span>
                        <span v-else>
                            <i class="fas fa-sort"></i>
                        </span>
                    </th>
                    <th @click="$emit('sort', 'acknowledgedReceived')">
                        Fecha acusa de recibido
                        <span v-if="contractStore.sortKey === 'acknowledgedReceived'">
                            <i :class="contractStore.sortOrder === 1 ? 'fa fa-arrow-up' : 'fa fa-arrow-down'"></i>
                        </span>
                        <span v-else>
                            <i class="fas fa-sort"></i>
                        </span>
                    </th>
                    <th @click="$emit('sort', 'acknowledgedKnown')">
                        Fecha acusa de enterado
                        <span v-if="contractStore.sortKey === 'acknowledgedKnown'">
                            <i :class="contractStore.sortOrder === 1 ? 'fa fa-arrow-up' : 'fa fa-arrow-down'"></i>
                        </span>
                        <span v-else>
                            <i class="fas fa-sort"></i>
                        </span>
                    </th>
                    <th @click="$emit('sort', 'name')">
                        Nombre
                        <span v-if="contractStore.sortKey === 'name'">
                            <i :class="contractStore.sortOrder === 1 ? 'fa fa-arrow-up' : 'fa fa-arrow-down'"></i>
                        </span>
                        <span v-else>
                            <i class="fas fa-sort"></i>
                        </span>
                    </th>
                    <th @click="$emit('sort', 'loanApplication.productType.name')">
                        Tipo de producto
                        <span v-if="contractStore.sortKey === 'loanApplication.productType.name'">
                            <i :class="contractStore.sortOrder === 1 ? 'fa fa-arrow-up' : 'fa fa-arrow-down'"></i>
                        </span>
                        <span v-else>
                            <i class="fas fa-sort"></i>
                        </span>
                    </th>
                    <th @click="$emit('sort', 'loanApplication.prospectus.personTypes.name')">
                        Tipo de persona
                        <span v-if="contractStore.sortKey === 'loanApplication.prospectus.personTypes.name'">
                            <i :class="contractStore.sortOrder === 1 ? 'fa fa-arrow-up' : 'fa fa-arrow-down'"></i>
                        </span>
                        <span v-else>
                            <i class="fas fa-sort"></i>
                        </span>
                    </th>
                    <th @click="$emit('sort', 'createdAt')">
                        Fecha de creación
                        <span v-if="contractStore.sortKey === 'createdAt'">
                            <i :class="contractStore.sortOrder === 1 ? 'fa fa-arrow-up' : 'fa fa-arrow-down'"></i>
                        </span>
                        <span v-else>
                            <i class="fas fa-sort"></i>
                        </span>
                    </th>
                    <th @click="$emit('sort', 'updatedAt')">
                        Fecha de actualización
                        <span v-if="contractStore.sortKey === 'updatedAt'">
                            <i :class="contractStore.sortOrder === 1 ? 'fa fa-arrow-up' : 'fa fa-arrow-down'"></i>
                        </span>
                        <span v-else>
                            <i class="fas fa-sort"></i>
                        </span>
                    </th>
                    <th>Acciones</th>
                </tr>
            </thead>
            <tbody>
                <template v-if="contracts.length > 0">
                    <tr v-for="contract in contracts" :key="contract.productContractId">
                        <td>{{ contract.referenceNumber }}</td>
                        <td>{{ contract.loanApplication.referenceNumber }}</td>
                        <td>{{ contract.loanApplication.prospectus.referenceNumber }}</td>
                        <td>{{ contract.loanApplication.prospectus.quotations.referenceNumber }}</td>
                        <td>{{ $filters.formatDate(contract.acknowledgedReceived) }}</td>
                        <td>{{ $filters.formatDate(contract.acknowledgedKnown) }}</td>
                        <td>{{ getName(contract) }}</td>
                        <td>{{ contract.loanApplication.productType.name }}</td>
                        <td>{{ contract.loanApplication.prospectus.personTypes.name }}</td>
                        <td>{{ $filters.formatDate(contract.createdAt) }}</td>
                        <td>{{ $filters.formatDate(contract.updatedAt) }}</td>
                        <td>
                            <PrimaryButton class="btn-success" @click="$emit('edit', contract)" data-toggle="modal"
                                data-target="#contractModal">
                                <i class="fa fa-edit"></i>
                            </PrimaryButton>
                        </td>
                    </tr>
                </template>
                <tr v-else>
                    <td colspan="11" style="text-align: center;">{{ $getLocaleMessage('common', 'noDataFound') }}</td>
                </tr>
            </tbody>
        </table>
    </div>
</template>

<script setup>
import PrimaryButton from '@/Components/PrimaryButton.vue';
import { useContractStore } from '@/pinia/LoanApplications/Legal/useContractStore.module';
import { getCurrentInstance } from 'vue';

const props = defineProps({
    contracts: {
        type: Array,
        required: true,
        default: () => []
    }
});

/**
 * Abre el modal para editar un registro de contrato
 * Acción por el boton de la tabla
 */
const emit = defineEmits(['sort', 'edit']);

const contractStore = useContractStore();

// Acceder a las propiedades globales
const instance = getCurrentInstance();
const $filters = instance?.appContext.config.globalProperties.$filters;

const getName = (item) => {
    if (item.loanApplication.prospectus.generalInformation.businessName === null) {
        return `${item.loanApplication.prospectus.generalInformation.firstName} ${item.loanApplication.prospectus.generalInformation.lastName} ${item.loanApplication.prospectus.generalInformation.mothersMaidenName}`;
    } else {
        return `${item.loanApplication.prospectus.generalInformation.businessName}`;
    }
}
</script>